export var dateMonthsBefore = function (date, months) {
    var currentMonth = date.getMonth();
    date.setMonth(currentMonth - months);
    if (currentMonth - months < 0 && date.getMonth() !== currentMonth + months) {
        date.setDate(0);
    }
    else if (currentMonth - months >= 0 &&
        date.getMonth() !== currentMonth - months) {
        date.setDate(0);
    }
    return date;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Date.ts
// module id = 484
// module chunks = 0